export type AvatarSize = 'xs' | 'sm' | 'md' | 'lg' | 'xl'

export const AVATAR_SIZES: Record<AvatarSize, { width: number; height: number; fontSize: number }> = {
    xs: {
        width: 16,
        height: 16,
        fontSize: 8,
    },
    sm: {
        width: 20,
        height: 20,
        fontSize: 10,
    },
    md: {
        width: 24,
        height: 24,
        fontSize: 11,
    },
    lg: {
        width: 36,
        height: 36,
        fontSize: 16,
    },
    xl: {
        width: 120,
        height: 120,
        fontSize: 40,
    },
}

export const getAvatarSizeStyles = (size: AvatarSize): { width: string; height: string; fontSize: string } => {
    const sizeConfig = AVATAR_SIZES[size]
    return {
        width: `${sizeConfig.width}px`,
        height: `${sizeConfig.height}px`,
        fontSize: `${sizeConfig.fontSize}px`,
    }
}

export const getAvatarIconSize = (size: AvatarSize): number => {
    switch (size) {
        case 'xs':
            return 12
        case 'sm':
            return 16
        case 'md':
            return 18
        case 'lg':
            return 24
        case 'xl':
            return 80
        default:
            return 20
    }
}
